/**
 * 项目   vue
 * 作者   loufei
 * 时间   2018/2/16
 */
import SockJS from 'sockjs-client';
const Stomp = require('stompjs');
let JGPWsClient;
export default class Socket {
    static connect(host, callback) {
        if (host[host.length - 1] !== '/') {
            host += '/';
        }
        JGPWsClient = Stomp.over(new SockJS(host + 'jgp-ws-server'));// 使用stomp子协议的WebSocket 客户端
        JGPWsClient.debug = (res) => {
            // console.log(res)
        }
        JGPWsClient.connect({}, (frame) => { // 链接Web Socket的服务端。
            if (callback) callback(frame);
        });
    }

    // 订阅广播消息
    static subscribeTopic(topicName, callback) {
        JGPWsClient.subscribe('/topic' + topicName, (respnose) => {
            if (callback) callback(respnose);
        });
    }

    // 订阅广播消息
    static subscribePoint(topicName, userId, callback) {
        JGPWsClient.subscribe('/user/' + userId + topicName, (respnose) => {
            if (callback) callback(respnose);
        });
    }
}
